import { lockScroll, releaseScroll } from '../utils/scrollLock';
import {getBreakpoint} from '../utils/breakpoints';

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetails = this.querySelector('details');
    this.mainSummary = this.mainDetails.querySelector('summary');
    this.summaryLink = this.mainSummary.querySelector('a');
    this.allDesktopNavDetails = document.querySelectorAll('.header__desktop-nav details');
    this.menuDetailsItems = this.querySelector('[details-items]');
    // The delay is needed to animate the closing of the details
    this.closeDelay = this.getAttribute('close-delay');
    this.closeTimeout;
    this.predictiveSearch = this.hasAttribute('data-predictive-search');
    if (this.predictiveSearch) {
      this.predictiveSearchInput = this.querySelector('[data-search-input]');
    }

    this.noScroll = this.hasAttribute("no-scroll"); //adds the class "no-scroll" to the body to prevent body scroll
    this.isTooltip = this.hasAttribute("data-is-tooltip");

    this.innerTrigger = false;

    // Support for share button feature
    this.printPageBtn = this.querySelector('[data-print-page]');
    if (this.printPageBtn) {
      this.printPageBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
        setTimeout(() => {
          window.print();
        }, 100);
      });
    }

    this.addEventListener('keyup', this.onKeyUp);

    if (this.hasAttribute('on-hover') && getBreakpoint() != 'mobile') {
      this.mainDetails.addEventListener('mouseenter', this.mouseenter.bind(this));
      this.mainDetails.addEventListener('mouseleave', this.mouseleave.bind(this));
    } else {
      this.mainSummary.addEventListener('click', this.toggle.bind(this));
    }

    if (this.summaryLink) {
      this.summaryLink.addEventListener('click', this.summaryLinkClick.bind(this));
    }

    if (this.isTooltip) {
      document.addEventListener('click', (event) => {
        const isInside = this.contains(event.target);

        if (!isInside && this.mainDetails.hasAttribute('open')) {
          this.close();
        }
      });
    }

    this.mainDetails.addEventListener('toggle', (event) => {
      // if details gets closed and innerTrigger is false then details has been closed trough other means (ie:escape key) and must be fully closed
      if (!event.target.hasAttribute("open") && !this.innerTrigger) {
        this.close();
        document.activeElement.blur(); // resets active element to document body
      }
    })
  }

  summaryLinkClick(event) {
    if (!this.mainDetails.hasAttribute('open')) {
      event.preventDefault();
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  mouseenter() {
    // first close all opened details
    this.allDesktopNavDetails.forEach((e) => {
      e.removeAttribute('open');
      e.setAttribute('closed', '');
    });

    this.open();
  }

  mouseleave() {
    this.close();
  }

  toggle(event) {
    if (event) {
      event.preventDefault();
    }

    if (this.mainDetails.hasAttribute('open')) {
      this.close();
    }
    else{
      this.open();
    }
  }

  open(className) {
    clearTimeout(this.closeTimeout);

    this.innerTrigger = false;

    if (this.noScroll) {
      lockScroll(className);
    }

    setTimeout(() => this.predictiveSearchInput?.focus(), this.closeDelay);

    this.mainDetails.setAttribute('open', '');
    this.mainDetails.removeAttribute('closing');
    this.mainDetails.removeAttribute('closed');
  }

  close(skipDelay, className) {
    if (this.noScroll && !this.skipScrollReset) {
      releaseScroll(className);
    } else if (this.skipScrollReset) {
      this.skipScrollReset = false;
    }

    if (this.closeDelay && !skipDelay) {
      this.mainDetails.setAttribute('closing', '');

      this.closeTimeout = setTimeout(() => {
        this.innerTrigger = true;
        this.mainDetails.removeAttribute('closing');
        this.mainDetails.removeAttribute('open');

        this.mainDetails.setAttribute('closed', '');
      }, this.closeDelay);
    }
    else {
      this.innerTrigger = true;
      this.mainDetails.setAttribute('closed', '');
      this.mainDetails.removeAttribute('open');
    }
  }
}

try {
  customElements.define('details-disclosure', DetailsDisclosure);
}
catch(e) {}


class DetailsSummaryLink extends HTMLElement {
  constructor() {
    super();

    this.summaryLink = this.querySelector('a');
    this.currentDetail = this.closest('details');
    this.currentDetailsDisclosure = this.currentDetail.parentElement.tagName == "DETAILS-DISCLOSURE" ? this.currentDetail.parentElement : null;

    if (this.summaryLink) {
      this.summaryLink.addEventListener('click', this.openLink.bind(this));
    }
  }

  openLink(event) {
    if (this.currentDetailsDisclosure) {
      if (!this.currentDetail.hasAttribute('open')) {
        event.preventDefault();

        this.currentDetailsDisclosure.toggle();
      }
    }
    else if (!this.currentDetail.hasAttribute('open')) {
      event.preventDefault();
      this.currentDetail.setAttribute('open', '');
    }
    else {
      window.location = this.summaryLink.href;
    }
  }
}

try {
  customElements.define('summary-link', DetailsSummaryLink);
}
catch(e) {}

class DetailsCloseButton extends HTMLElement {
  constructor() {
    super();

    this.closestDetailsDisclosure = this.closest('details-disclosure');
    this.closestDetails = this.closest('details');
    this.closeButton = this.querySelector('button');

    /**
     * having a button is better for accessibility but
     * some case might be better without.
     *
     * e.g. The background of a popup that can be used to close it
     */
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.onClick.bind(this));
    }
    else {
      this.addEventListener('click', this.onClick.bind(this));
    }
  }

  onClick(event) {
    event.preventDefault();

    if (this.closestDetailsDisclosure) {
      this.closestDetailsDisclosure.close(null, 'no-scroll--cart');
    }
    else {
      this.closestDetails.removeAttribute('open');
      this.closestDetails.setAttribute('closed', '');
    }
  }
}

try {
  customElements.define('close-details', DetailsCloseButton);
}
catch(e) {}
